<template>
    <div id="tour-student-settings-page" class="flex flex-1 space-x-2 ">
      <DashboardHeaderTab
      :title="'Settings'"
      :tabs="tabs"
      :activeTab="activeTab"
      :setActiveTab="setActiveTab"
      :toggleSidebar="toggleSidebar"
  />

    </div>
</template>

<script setup lang="ts">

import UpdateProfile from '@/components/StudentDashboard/Settings/UpdateProfile.vue';
import DashboardHeaderTab from '@/components/DashBoard/common/DashboardHeaderTab.vue';
import { useTabs } from '@/composables/useTabs';
import ResetPassword from '@/components/StudentDashboard/Settings/ResetPassword.vue';
import PreferencesTab from '@/components/StudentDashboard/Settings/PreferencesTab.vue';

const toggleSidebar = inject<() => void>('toggleSidebar', () => {});

// Define the tabs
const tabs = ref([
  { name: 'Reset Password', component: ResetPassword, query: '' },
  { name: 'Update Profile', component: UpdateProfile, query: 'update' },
  { name: 'Preferences', component: PreferencesTab, query: 'preferences' },
]);

// Use the composable for tab management
const { activeTab, setActiveTab } = useTabs(tabs);

</script>

<style lang="scss" scoped>

</style>
